const STATIC_PATH = '/static/img';

const FACEBOOK_ADS = 'facebook_ads';
const GOOGLE_ADS = 'google_ads';
const GOOGLE_ANALYTICS = 'google_analytics';
const VTEX = 'vtex';
const WOOCOMMERCE = 'woocommerce';
const LOJA_INTEGRADA = 'loja-integrada';
const PIPEDRIVE = 'pipedrive';
const MOBEES = 'mobees';
const TRAKTO = 'trakto';
const CLIENT = 'client';


export const PLATFORMS = {
    FACEBOOK_ADS: {
        name: 'Facebook Ads',
        value: 'facebook_ads',
        type: 'ads_platform',
    },
    GOOGLE_ADS: {
        name: 'Google Ads',
        value: 'google_ads',
        type: 'ads_platform',
    },
    GOOGLE_ANALYTICS: {
        name: 'Google Analytics',
        value: 'google_analytics',
        type: 'analytics',
    },
    VTEX: {
        name: 'Vtex',
        value: 'vtex',
        type: 'ecommerce',
    },
    WOOCOMMERCE: {
        name: 'WooCommerce',
        value: 'woocommerce',
        type: 'ecommerce',
    },
    LOJA_INTEGRADA: {
        name: 'Loja Integrada',
        value: 'loja-integrada',
        type: 'ecommerce',
    },
    PIPEDRIVE: {
        name: 'Pipedrive',
        value: 'pipedrive',
        type: 'crm',
    },
    MOBEES: {
        name: 'Mobees',
        value: 'mobees',
        type: 'partnership',
    },
    TRAKTO: {
        name: 'Trakto',
        value: 'trakto',
        type: 'partnership',
    },
    CLIENT: {
        name: 'Client',
        value: 'client',
        type: 'client',
    },
};

export const STRINGFY_PLATFORMS = {
    [FACEBOOK_ADS]: PLATFORMS.FACEBOOK_ADS,
    [GOOGLE_ADS]: PLATFORMS.GOOGLE_ADS,
    [GOOGLE_ANALYTICS]: PLATFORMS.GOOGLE_ANALYTICS,
    [VTEX]: PLATFORMS.VTEX,
    [WOOCOMMERCE]: PLATFORMS.WOOCOMMERCE,
    [LOJA_INTEGRADA]: PLATFORMS.LOJA_INTEGRADA,
    [PIPEDRIVE]: PLATFORMS.PIPEDRIVE,
    [MOBEES]: PLATFORMS.MOBEES,
    [TRAKTO]: PLATFORMS.TRAKTO,
    [CLIENT]: PLATFORMS.CLIENT,
};

export const PLATFORM_LOGOS = {
    google_ads: {
        SRC: `${STATIC_PATH}/svg/ads_cinza.svg`,
        ALT: 'Google Ads',
        NAME: 'Google Ads',
        VALUE: 'google_ads',
    },
    google_analytics: {
        SRC: `${STATIC_PATH}/svg/google_analytics_cinza.svg`,
        ALT: 'Google Analytics',
        NAME: 'Google Analytics',
        VALUE: 'google_analytics',
    },
    facebook_ads: {
        SRC: `${STATIC_PATH}/svg/facebook_cinza.svg`,
        ALT: 'Facebook Ads',
        NAME: 'Facebook Ads',
        VALUE: 'facebook_ads',
    },
    linkedin_ads: {
        SRC: `${STATIC_PATH}/svg/linkedin_cinza.svg`,
        ALT: 'Linkedin Ads',
        NAME: 'Linkedin Ads',
        VALUE: 'linkedin_ads',
    },
    seo: {
        SRC: `${STATIC_PATH}/svg/seo_cinza.svg`,
        ALT: 'SEO',
        NAME: 'SEO',
        VALUE: 'seo',
    },
    waze_ads: {
        SRC: `${STATIC_PATH}/svg/waze_cinza.svg`,
        ALT: 'Waze Ads',
        NAME: 'Waze Ads',
        VALUE: 'waze_ads',
    },
    bing_ads: {
        SRC: `${STATIC_PATH}/svg/bing_ads_cinza.svg`,
        ALT: 'Bing Ads',
        NAME: 'Bing Ads',
        VALUE: 'bing_ads',
    },
    criteo_ads: {
        SRC: `${STATIC_PATH}/svg/critero_ads_cinza.svg`,
        ALT: 'Criteo Ads',
        NAME: 'Criteo Ads',
        VALUE: 'criteo_ads',
    },
};
